module.exports = __webpack_public_path__ + "img/open-credit-card-button.b397719b.png";